import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'expansionhostguide'
})
export class ExpandedHostGuide implements PipeTransform {

  transform(alertindex:number,eventindex:number,expandedhostdetails:Array<string>,openoption:string,closedoption:string) {
    if(expandedhostdetails.length){
      return expandedhostdetails.indexOf(alertindex.toString()+eventindex.toString())+1 ? openoption : closedoption;
    }else{
      return closedoption
    }
  }
}